// vue.config.js
module.exports = {
    INVALID_TOKEN: 'Invalid Token',
    API_ENDPOINT: 'https://m5.tunai.io',
    API_ENDPOINT_ORDER:'https://order.tunai.io',
    API_ENDPOINT_BEBUSINESS:'https://bebusiness.tunai.io',
    API_ENDPOINT_REPORT: 'https://report.tunai.io',
    API_ENDPOINT_STAFF: 'https://staff.tunai.io',
    API_ENDPOINT_MENU: 'https://menu.tunai.io',
    API_ENDPOINT_MEMBER:'https://member.tunai.io',
    CDR: 'https://order.tunai.io:8080/business/cdr',
    API_IMAGE: 'https://img.tunai.io/image',
    API_WA: 'https://wa.me/',
    URL_TUKANG: 'https://www.tukang.io/',
    LOGIN: '/business/authen/login',
    LOGOUT: '/logout',
    RESET_PASSWORD: '/business/authen/forgot',
    CHANGE_PASSWORD: '/business/authen/change',
    CHANGE_LOYALTY_PASSWORD: '/passwd/change',
    MENU_ITEM: '/business/setting/menu/item',
    MENU_FOLDER: '/business/setting/menu/folder',
    MENU_CATEGORY: '/business/setting/menu/category',
    MENU_TREATMENT: '/business/setting/menu/treatment',
    MENU_THERAPY: '/business/setting/menu/therapy',
    ITEM_POLICY: '/policy',
    PACKAGE_DETAIL: '/detail',
    MENU_REWARD_QR: '/rewardqr',
    MESSAGE: '/business/trxn/messages',
    MEMBER: '/member',
    MEMBER2: 'https://member.tunai.io/business/member',
    BIZ_MEMBER: '/business/member',
    MEMBER_CONFIGURE: '/business/setting/configure',
    CHANGE_MOBILE: '/business/trxn/member/changeMobile',
    DELETED_MEMBER: '/business/trxn/member/delete',
    BRAND_CHECKLIST: '/business/setting/checklist',
    BRAND_CONFIG: '/business/setting/configure',
    BRAND_PAYMENT: '/business/setting/payments',
    BRAND_SETTING: '/business/setting',
    USER: '/business/setting/users',
    USERS: '/users',
    PERMISSION: '/business/permission',
    USER_PERMISSION: '/perm',
    USER_OUTLET: '/outlets',
    OUTLET: '/business/outlet',
    SECURITY: '/security',
    CITY: '/city',
    INFO: '/info',
    BOOKING: '/business/book',
    BOOK_MESSAGE: '/book/message',
    RECEIPT: '/receipt',
    SOCIAL_MEDIA: '/social',
    BOOKING_BLOCK: '/block',
    BROADCAST: '/business/trxn/bcasts',
    BROADCAST_TARGET: '/targets',
    BROADCAST_TUKANG: '/tkpost',
    BROADCAST_REPOST: '/repost',
    STAFF: '/staff',
    BEBUSINESS_STAFF: '/business/staff',
    STAFF_TARGET_UPDATE:'/target/update',
    STAFF_DETAIL_UPDATE:'/update',
    STAFF_ROSTER: '/business/staff/breaks',
    BREAK_TYPE: '/info/breakType',
    SETUP: '/setup',
    IMAGES: '/images',
    REPORT: '/report',
    REPORT_PAYMENT: '/business/trxn/collections',
    REPORT_CREDIT: '/business/trxn/credits',
    REPORT_OUTSTANDINGS: '/business/trxn/outstandings',
    REPORT_POINTS: '/business/trxn/points',
    REPORT_COMPLETED: '/business/trxn/completed',
    REPORT_SALES: '/business/trxn/sales',
    REPORT_VOUCHER: '/business/trxn/vouchers',
    REPORT_REWARD: '/business/trxn/rewardqr',
    REPORT_ATTENDANCE: '/attendance',
    REPORT_DATTENDANCE: '/business/dattendance',
    REPORT_VISIT: 'https://bebusiness.tunai.io/visit',
    REPORT_POKE: 'https://bebusiness.tunai.io/poke',
    REPORT_BALANCE: '/balance',
    REWARDQR: 'https://bebusiness.tunai.io/rewardqr',
    STOCK_BALANCE: '/stockbalance',
    STOCK: '/stock',
    INVENTORY: '/inventory',
    DELETE: '/delete',
    UPDATE: '/update',
    TYPE: '/type',
    TUKANG_ALL_POST: '/business/tukang/posts',
    TUKANG_SHOP: '/business/tukang/shop',
    TUKANG_STAFF: '/staffs',
    TUKANG_TYPE: '/business/tukang/type',
    TUKANG_CATEGORY: '/business/tukang/category',
    TUKANG_POST: '/posts',
    TUKANG_ORDER: '/business/tukang/orders',
    VOUCHER: 'https://bebusiness.tunai.io/trxn/vouchers/',
    BEBUSINESS_OUTLET: 'https://bebusiness.tunai.io/outlet/',
    WASSENGER: '/communication/wassenger',
    TWILLIO: '/communication/twilio',

    BUSINESS_SALES: '/business/sales',
}